// @ts-nocheck - generated mutations
/* tslint:disable */
/* eslint-disable */

import * as APITypes from "../models/API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createUserPreference =
  /* GraphQL */ `mutation CreateUserPreference(
  $input: CreateUserPreferenceInput!
) {
  createUserPreference(input: $input) {
    id
    user_id
    team_weblab_id
    watch_flag
    comments
    __typename
  }
}
` as GeneratedMutation<
    APITypes.CreateUserPreferenceMutationVariables,
    APITypes.CreateUserPreferenceMutation
  >;
export const createTeamPreference =
  /* GraphQL */ `mutation CreateTeamPreference(
  $input: CreateTeamPreferenceInput!
) {
  createTeamPreference(input: $input) {
    id
    team_id
    team_weblab_id
    watch_flag
    comments
    additional_columns
    __typename
  }
}
` as GeneratedMutation<
    APITypes.CreateTeamPreferenceMutationVariables,
    APITypes.CreateTeamPreferenceMutation
  >;
export const updateTeamPreference =
  /* GraphQL */ `mutation UpdateTeamPreference(
  $input: UpdateTeamPreferenceInput!
) {
  updateTeamPreference(input: $input) {
    id
    team_id
    team_weblab_id
    watch_flag
    comments
    additional_columns
    __typename
  }
}
` as GeneratedMutation<
    APITypes.UpdateTeamPreferenceMutationVariables,
    APITypes.UpdateTeamPreferenceMutation
  >;

export const updateTeam = /* GraphQL */ `mutation UpdateTeam(
  $input: UpdateTeamInput!
) {
  updateTeam(input: $input) {
    id
    name
    custom_attributes
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTeamMutationVariables,
  APITypes.UpdateTeamMutation
>;
export const updateTeamUserMap = /* GraphQL */ `mutation UpdateTeamUserMap(
  $input: UpdateTeamUserMapInput!
) {
  updateTeamUserMap(input: $input) {
    team_id
    user_id
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTeamUserMapMutationVariables,
  APITypes.UpdateTeamUserMapMutation
>;
export const updateTeamUserAttributes =
  /* GraphQL */ `mutation UpdateTeamUserAttributes(
  $input: UpdateTeamUserAttributesInput!
) {
  updateTeamUserAttributes(input: $input) {
    team_id
    user_id
    attributes
    __typename
  }
}
` as GeneratedMutation<
    APITypes.UpdateTeamUserAttributesMutationVariables,
    APITypes.UpdateTeamUserAttributesMutation
  >;
export const createUser = /* GraphQL */ `mutation CreateUser(
  $input: CreateUserInput!
) {
  createUser(input: $input) {
    id
    user_name
    attributes
    login_times
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserMutationVariables,
  APITypes.CreateUserMutation
>;
export const createUserRequest = /* GraphQL */ `mutation CreateUserRequest(
  $input: CreateUserRequestInput!
) {
  createUserRequest(input: $input) {
    team_id
    user_id
    status
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserRequestMutationVariables,
  APITypes.CreateUserRequestMutation
>;
export const handleUserRequest = /* GraphQL */ `mutation HandleUserRequest(
  $input: HandleUserRequestInput!
) {
  handleUserRequest(input: $input) {
    team_id
    user_id
    status
    __typename
  }
}
` as GeneratedMutation<
  APITypes.HandleUserRequestMutationVariables,
  APITypes.HandleUserRequestMutation
>;
export const writeAccessRequests = /* GraphQL */ `mutation WriteAccessRequests(
  $input: WriteAccessRequestsInput!
) {
  writeAccessRequests(input: $input) {
    message_id
    __typename
  }
}
` as GeneratedMutation<
  APITypes.WriteAccessRequestsMutationVariables,
  APITypes.WriteAccessRequestsMutation
>;
export const processTicketyEvents =
  /* GraphQL */ `mutation ProcessTicketyEvents(
  $input: TicketInput!
) {
  processTicketyEvents(input: $input) {
    success
    message
    __typename
  }
}
` as GeneratedMutation<
    APITypes.ProcessTicketyEventsMutationVariables,
    APITypes.ProcessTicketyEventsMutation
  >;
export const askAI = /* GraphQL */ `mutation askAI(
  $input: AskAIInput!
) {
  askAI(input: $input) {
    conversation_id
    success
    message
    response
    __typename
  }
}
` as GeneratedMutation<APITypes.AskAIMutationVariables, APITypes.AskAIMutation>;
export const submitQuestion = /* GraphQL */ `mutation submitQuestion(
  $input: SubmitQuestionInput!
) {
  submitQuestion(input: $input) {
    conversation_id
    question_id
    success
    message
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SubmitQuestionMutationVariables,
  APITypes.SubmitQuestionMutation
>;
export const addToolConfig = /* GraphQL */ `mutation addToolConfig(
  $input: AddToolConfigInput!
) {
  addToolConfig(input: $input) {
    id
    name
    description
    input_schema
    user_id
    is_public
    accessor_arn
    tool_category
    tool_type
    created_at
    updated_at
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AddToolConfigMutationVariables,
  APITypes.AddToolConfigMutation
>;
export const createCsvUploadUrl = /* GraphQL */ `mutation CreateCsvUploadUrl(
  $input: CreateCsvUploadUrlInput!
) {
  createCsvUploadUrl(input: $input) {
    upload_url
    file_key
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCsvUploadUrlMutationVariables,
  APITypes.CreateCsvUploadUrlMutation
>;
export const createPdfUploadUrl = /* GraphQL */ `mutation CreatePdfUploadUrl(
  $input: CreatePdfUploadUrlInput!
) {
  createPdfUploadUrl(input: $input) {
    upload_url
    file_key
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePdfUploadUrlMutationVariables,
  APITypes.CreatePdfUploadUrlMutation
>;
export const createWbrPublishUploadUrls =
  /* GraphQL */ `mutation CreateWbrPublishUploadUrls(
  $input: CreateWbrPublishUploadUrlsInput!
) {
  createWbrPublishUploadUrls(input: $input) {
    bucket
    targets {
      file_name
      upload_url
      file_key
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
    APITypes.CreateWbrPublishUploadUrlsMutationVariables,
    APITypes.CreateWbrPublishUploadUrlsMutation
  >;
export const addDataSource = /* GraphQL */ `mutation addDataSource(
  $input: AddDataSourceInput!
) {
  addDataSource(input: $input) {
    id
    team_id
    display_name
    data_source_type
    tool_id
    is_public
    creator_id
    updated_by
    created_at
    updated_at
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AddDataSourceMutationVariables,
  APITypes.AddDataSourceMutation
>;
export const deleteDataSource = /* GraphQL */ `mutation deleteDataSource(
  $input: DeleteDataSourceInput!
) {
  deleteDataSource(input: $input) {
    id
    display_name
    data_source_type
    tool_id
    is_public
    creator_id
    updated_by
    created_at
    updated_at
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDataSourceMutationVariables,
  APITypes.DeleteDataSourceMutation
>;
export const addUserKnowledge = /* GraphQL */ `mutation addUserKnowledge(
  $input: AddUserKnowledgeInput!
) {
  addUserKnowledge(input: $input) {
    id
    team_id
    knowledge_name
    description
    knowledge_type
    is_public
    content
    attributes
    creator_id
    updated_by
    created_at
    updated_at
    folder_id
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AddUserKnowledgeMutationVariables,
  APITypes.AddUserKnowledgeMutation
>;
export const deleteUserKnowledge = /* GraphQL */ `mutation deleteUserKnowledge(
  $input: DeleteUserKnowledgeInput!
) {
  deleteUserKnowledge(input: $input) {
    id
    knowledge_name
    description
    knowledge_type
    is_public
    content
    attributes
    creator_id
    updated_by
    created_at
    updated_at
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserKnowledgeMutationVariables,
  APITypes.DeleteUserKnowledgeMutation
>;
export const startBRJob = /* GraphQL */ `mutation startBRJob(
  $input: StartBRJobInput!
) {
  startBRJob(input: $input) {
    success
    job_id
    execution_arn
    message
    error
    __typename
  }
}
` as GeneratedMutation<
  APITypes.StartBRJobMutationVariables,
  APITypes.StartBRJobMutation
>;
export const loadCsvToRedshift = /* GraphQL */ `mutation loadCsvToRedshift(
  $input: LoadCsvToRedshiftInput!
) {
  loadCsvToRedshift(input: $input) {
    table_name
    status
    copy_ddl
    create_table_ddl
    message
    __typename
  }
}
` as GeneratedMutation<
  APITypes.LoadCsvToRedshiftMutationVariables,
  APITypes.LoadCsvToRedshiftMutation
>;
export const setUserProfile = /* GraphQL */ `mutation setUserProfile(
  $input: SetUserProfileInput!
) {
  setUserProfile(input: $input) {
    id
    login_times
    user_name
    attributes
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SetUserProfileMutationVariables,
  APITypes.SetUserProfileMutation
>;
export const submitConversationFeedback =
  /* GraphQL */ `mutation submitConversationFeedback(
  $input: SubmitConversationFeedbackInput!
) {
  submitConversationFeedback(input: $input) {
    user_id
    conversation_id
    feedback
    feedback_at
    __typename
  }
}
` as GeneratedMutation<
    APITypes.SubmitConversationFeedbackMutationVariables,
    APITypes.SubmitConversationFeedbackMutation
  >;

export const saveDashboardCache = /* GraphQL */ `mutation SaveDashboardCache(
  $input: SaveDashboardCacheInput!
) {
  saveDashboardCache(input: $input) {
    pk
    sk
    dashboard_id
    report_data
    ai_summaries
    ttl
    created_at
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SaveDashboardCacheMutationVariables,
  APITypes.SaveDashboardCacheMutation
>;

export const askAI2 = /* GraphQL */ `mutation askAI2(
  $input: AskAI2Input!
) {
  askAI2(input: $input) {
    conversation_id
    success
    message
    response
    thinking
    sources
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AskAI2MutationVariables,
  APITypes.AskAI2Mutation
>;
export const submitQuestion2 = /* GraphQL */ `mutation submitQuestion2(
  $input: SubmitQuestion2Input!
) {
  submitQuestion2(input: $input) {
    conversation_id
    question_id
    success
    message
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SubmitQuestion2MutationVariables,
  APITypes.SubmitQuestion2Mutation
>;

export const syncKnowledge = /* GraphQL */ `mutation syncKnowledge(
  $input: SyncKnowledgeInput!
) {
  syncKnowledge(input: $input) {
    success
    message
    __typename
  }
}
` as GeneratedMutation<any, any>;

export const addManualCallout = /* GraphQL */ `mutation addManualCallout(
  $input: AddManualCalloutInput!
) {
  addManualCallout(input: $input) {
    id
    team_id
    week
    report_name
    page_num
    title
    status
    trend
    why_text
    creator_id
    creator_name
    updated_by
    updated_by_name
    created_at
    updated_at
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AddManualCalloutMutationVariables,
  APITypes.AddManualCalloutMutation
>;
export const updateManualCallout = /* GraphQL */ `mutation updateManualCallout(
  $input: UpdateManualCalloutInput!
) {
  updateManualCallout(input: $input) {
    id
    team_id
    week
    report_name
    page_num
    title
    status
    trend
    why_text
    creator_id
    creator_name
    updated_by
    updated_by_name
    created_at
    updated_at
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateManualCalloutMutationVariables,
  APITypes.UpdateManualCalloutMutation
>;
export const deleteManualCallout = /* GraphQL */ `mutation deleteManualCallout(
  $input: DeleteManualCalloutInput!
) {
  deleteManualCallout(input: $input) {
    id
    team_id
    week
    report_name
    page_num
    title
    status
    trend
    why_text
    creator_id
    creator_name
    updated_by
    updated_by_name
    created_at
    updated_at
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteManualCalloutMutationVariables,
  APITypes.DeleteManualCalloutMutation
>;

export const createKnowledgeFolder =
  /* GraphQL */ `mutation createKnowledgeFolder(
  $input: CreateKnowledgeFolderInput!
) {
  createKnowledgeFolder(input: $input) {
    id
    folder_name
    team_id
    is_public
    is_global
    creator_id
    creator_name
    updated_by
    updated_by_name
    created_at
    updated_at
    item_count
    __typename
  }
}
` as GeneratedMutation<
    APITypes.CreateKnowledgeFolderMutationVariables,
    APITypes.CreateKnowledgeFolderMutation
  >;

export const renameKnowledgeFolder =
  /* GraphQL */ `mutation renameKnowledgeFolder(
  $input: RenameKnowledgeFolderInput!
) {
  renameKnowledgeFolder(input: $input) {
    id
    folder_name
    team_id
    is_public
    is_global
    creator_id
    creator_name
    updated_by
    updated_by_name
    created_at
    updated_at
    item_count
    __typename
  }
}
` as GeneratedMutation<
    APITypes.RenameKnowledgeFolderMutationVariables,
    APITypes.RenameKnowledgeFolderMutation
  >;

export const deleteKnowledgeFolder =
  /* GraphQL */ `mutation deleteKnowledgeFolder(
  $input: DeleteKnowledgeFolderInput!
) {
  deleteKnowledgeFolder(input: $input) {
    id
    folder_name
    team_id
    is_public
    is_global
    creator_id
    creator_name
    updated_by
    updated_by_name
    created_at
    updated_at
    item_count
    __typename
  }
}
` as GeneratedMutation<
    APITypes.DeleteKnowledgeFolderMutationVariables,
    APITypes.DeleteKnowledgeFolderMutation
  >;

// =============================================================
// Unified Callout mutations (wbr-unified-callouts spec)
// =============================================================

export const addCallout = /* GraphQL */ `mutation addCallout(
  $input: AddCalloutInput!
) {
  addCallout(input: $input) {
    id
    team_id
    week
    report_name
    page_num
    source
    title
    status
    trend
    why_text
    impact
    card_number
    cell_refs {
      row
      col
      cell_map_version
      __typename
    }
    sparkline_data {
      values
      num_weeks
      label
      __typename
    }
    creator_id
    creator_name
    updated_by
    updated_by_name
    created_at
    updated_at
    ai_generation_batch_id
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AddCalloutMutationVariables,
  APITypes.AddCalloutMutation
>;

export const updateCallout = /* GraphQL */ `mutation updateCallout(
  $input: UpdateCalloutInput!
) {
  updateCallout(input: $input) {
    id
    team_id
    week
    report_name
    page_num
    source
    title
    status
    trend
    why_text
    impact
    card_number
    cell_refs {
      row
      col
      cell_map_version
      __typename
    }
    sparkline_data {
      values
      num_weeks
      label
      __typename
    }
    creator_id
    creator_name
    updated_by
    updated_by_name
    created_at
    updated_at
    ai_generation_batch_id
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCalloutMutationVariables,
  APITypes.UpdateCalloutMutation
>;

export const deleteCallout = /* GraphQL */ `mutation deleteCallout(
  $input: DeleteCalloutInput!
) {
  deleteCallout(input: $input) {
    id
    team_id
    week
    report_name
    page_num
    source
    title
    status
    trend
    why_text
    cell_refs {
      row
      col
      cell_map_version
      __typename
    }
    sparkline_data {
      values
      num_weeks
      label
      __typename
    }
    creator_id
    creator_name
    updated_by
    updated_by_name
    created_at
    updated_at
    ai_generation_batch_id
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCalloutMutationVariables,
  APITypes.DeleteCalloutMutation
>;

export const updateCalloutSummary =
  /* GraphQL */ `mutation updateCalloutSummary(
  $input: UpdateCalloutSummaryInput!
) {
  updateCalloutSummary(input: $input) {
    team_id
    week
    report_name
    overview
    kpi_strip {
      label
      value
      sub
      color
    }
    key_callouts {
      page_num
      card_number
    }
    content
    creator_id
    creator_name
    updated_by
    updated_by_name
    created_at
    updated_at
    __typename
  }
}
` as GeneratedMutation<
    APITypes.UpdateCalloutSummaryMutationVariables,
    APITypes.UpdateCalloutSummaryMutation
  >;

// =============================================================
// Share link mutations (share-link spec)
// =============================================================

export const generateShareLink = /* GraphQL */ `mutation generateShareLink(
  $input: GenerateShareLinkInput!
) {
  generateShareLink(input: $input) {
    share_token
    share_url
    conversation_id
    status
    created_at
    snapshot_updated_at
    __typename
  }
}
` as GeneratedMutation<
  APITypes.GenerateShareLinkMutationVariables,
  APITypes.GenerateShareLinkMutation
>;

export const revokeShareLink = /* GraphQL */ `mutation revokeShareLink(
  $input: RevokeShareLinkInput!
) {
  revokeShareLink(input: $input) {
    share_token
    status
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.RevokeShareLinkMutationVariables,
  APITypes.RevokeShareLinkMutation
>;

export const updateShareSnapshot = /* GraphQL */ `mutation updateShareSnapshot(
  $input: UpdateShareSnapshotInput!
) {
  updateShareSnapshot(input: $input) {
    share_token
    share_url
    conversation_id
    status
    created_at
    snapshot_updated_at
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateShareSnapshotMutationVariables,
  APITypes.UpdateShareSnapshotMutation
>;

export const addSharedConversation =
  /* GraphQL */ `mutation addSharedConversation(
  $input: AddSharedConversationInput!
) {
  addSharedConversation(input: $input) {
    conversation_id
    success
    __typename
  }
}
` as GeneratedMutation<
    APITypes.AddSharedConversationMutationVariables,
    APITypes.AddSharedConversationMutation
  >;
// Idempotent, one-time-per-user backfill of the conversation index. Conversations
// written before the index existed have no header item, so listConversations (which
// reads the index) would not see them. Cheap to call on every mount: after the first
// run it short-circuits on a per-user sentinel.
export const ensureConversationIndex =
  /* GraphQL */ `mutation ensureConversationIndex(
  $input: EnsureConversationIndexInput!
) {
  ensureConversationIndex(input: $input) {
    ready
    indexed
    migrated
    __typename
  }
}
` as GeneratedMutation<
    APITypes.EnsureConversationIndexMutationVariables,
    APITypes.EnsureConversationIndexMutation
  >;
// Published reports (FINN 3 / F1). Neither mutation selects `content`: the
// dialog already holds the markdown it sent, and the dashboard re-reads one
// report with getPublishedReport when it needs the body.
export const publishReport = /* GraphQL */ `mutation publishReport(
  $input: PublishReportInput!
) {
  publishReport(input: $input) {
    id
    team_id
    team_name
    title
    description
    question
    conversation_id
    source
    is_public
    is_global
    creator_id
    creator
    updated_by
    last_updated_by
    created_at
    updated_at
    published_at
    refresh_mode
    last_run_at
    last_run_status
    run_count
    __typename
  }
}
` as GeneratedMutation<
  APITypes.PublishReportMutationVariables,
  APITypes.PublishReportMutation
>;
export const unpublishReport = /* GraphQL */ `mutation unpublishReport(
  $input: UnpublishReportInput!
) {
  unpublishReport(input: $input) {
    id
    team_id
    title
    is_public
    is_global
    creator_id
    updated_at
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UnpublishReportMutationVariables,
  APITypes.UnpublishReportMutation
>;
// Refreshable published reports (FINN 3 / F2). startReportRun is served by the
// publish_report_runner Lambda (enqueues a fresh Ask AI turn); recordReportRun
// is an RDS resolver that finishes/inserts the run row and, on success, swaps
// the report's content in the same statement. Neither selects `content`.
export const startReportRun = /* GraphQL */ `mutation startReportRun(
  $input: StartReportRunInput!
) {
  startReportRun(input: $input) {
    run_id
    run_thread
    run_turn_id
    started_at
    __typename
  }
}
` as GeneratedMutation<
  APITypes.StartReportRunMutationVariables,
  APITypes.StartReportRunMutation
>;
export const recordReportRun = /* GraphQL */ `mutation recordReportRun(
  $input: RecordReportRunInput!
) {
  recordReportRun(input: $input) {
    id
    report_id
    run_thread
    run_turn_id
    status
    question
    request_scope
    content_preview
    error_type
    input_tokens
    output_tokens
    triggered_by
    triggered_by_name
    started_at
    finished_at
    __typename
  }
}
` as GeneratedMutation<
  APITypes.RecordReportRunMutationVariables,
  APITypes.RecordReportRunMutation
>;
// Report subscriptions (FINN 3 / F3). Both are RDS resolvers that derive the
// actor from the Cognito identity; `user_id` is advisory. unsubscribeFromReport
// takes the subscription id (unsubscribe link, My subscriptions) or the report
// id (the bell on a report); `was_active` says whether this call ended it.
export const subscribeToReport = /* GraphQL */ `mutation subscribeToReport(
  $input: SubscribeToReportInput!
) {
  subscribeToReport(input: $input) {
    id
    report_id
    cadence
    channel
    active
    active_since
    ended_reason
    created_at
    updated_at
    last_period_key
    last_delivery_status
    last_delivery_detail
    last_delivered_at
    report_title
    report_team_id
    report_team_name
    report_is_public
    report_is_global
    report_active
    report_refresh_mode
    report_published_at
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SubscribeToReportMutationVariables,
  APITypes.SubscribeToReportMutation
>;
export const unsubscribeFromReport =
  /* GraphQL */ `mutation unsubscribeFromReport(
  $input: UnsubscribeFromReportInput!
) {
  unsubscribeFromReport(input: $input) {
    id
    report_id
    cadence
    channel
    active
    active_since
    ended_reason
    created_at
    updated_at
    last_period_key
    last_delivery_status
    last_delivery_detail
    last_delivered_at
    report_title
    report_team_id
    report_team_name
    report_is_public
    report_is_global
    report_active
    report_refresh_mode
    report_published_at
    was_active
    __typename
  }
}
` as GeneratedMutation<
    APITypes.UnsubscribeFromReportMutationVariables,
    APITypes.UnsubscribeFromReportMutation
  >;
